// Custom emotes in a message: `:code:` stands for an image the admin dropped in the web
// bucket (see serverless/src/lib/emotes.js). Anything not on the list stays as text.

const TOKEN = /:([a-z0-9_-]{1,32}):/gi;
const JUMBO_MAX = 5; // a message that is only emotes, up to this many, shows them big
export const MESSAGE_MAX = 500; // what the room accepts

const byCode = (emotes) => new Map(emotes.map((emote) => [emote.code.toLowerCase(), emote]));

/** The message as a list of parts: `{ text }` and `{ emote: { code, url } }`, in order */
export const splitEmotes = (content, emotes) => {
  const text = String(content ?? '');
  if (!emotes?.length) return text ? [{ text }] : [];
  const known = byCode(emotes);
  const parts = [];
  const pushText = (value) => {
    if (!value) return;
    const last = parts[parts.length - 1];
    if (last?.text !== undefined) last.text += value;
    else parts.push({ text: value });
  };
  let at = 0;
  for (const match of text.matchAll(TOKEN)) {
    const emote = known.get(match[1].toLowerCase());
    if (!emote) continue; // not an emote: the colons stay as they were typed
    pushText(text.slice(at, match.index));
    parts.push({ emote });
    at = match.index + match[0].length;
  }
  pushText(text.slice(at));
  return parts;
};

// Nothing but emotes (and spaces), and not too many of them
export const isEmotesOnly = (parts) => {
  const emotes = parts.filter((part) => part.emote).length;
  return emotes > 0 && emotes <= JUMBO_MAX && parts.every((part) => part.emote || !part.text.trim());
};

/** The draft with `:code:` dropped in at the cursor, spaced from what is around it */
export const insertEmote = (draft, code, cursor = draft.length) => {
  const before = draft.slice(0, cursor);
  const after = draft.slice(cursor);
  const token = `${before && !/\s$/.test(before) ? ' ' : ''}:${code}:${/^\s/.test(after) ? '' : ' '}`;
  const text = `${before}${token}${after}`;
  if (text.length > MESSAGE_MAX) return { text: draft, cursor };
  return { text, cursor: before.length + token.length };
};
